import React from 'react';

import loadServiceWorker from 'Jsx/ServiceWorker/loadServiceWorker';
import getRenderMethod from './getRenderMethod';

const renderAndInitializeMainApp = (
  MainComponent: React.ReactElement,
  node?: HTMLElement | null,
  callback?: () => void,
  options?: { ssr: boolean },
) => {
  const nodeId = '#mainNode';
  const render = getRenderMethod(nodeId, options);

  render(MainComponent, node || document.querySelector(nodeId), () => {
    // After render the main app we need to initialize our main services
    if (callback) {
      callback();
    }

    // service worker setup
    window.addEventListener('load', () => {
      if (window.requestIdleCallback) {
        window.requestIdleCallback(loadServiceWorker);
      }
    });
  });
};

export default renderAndInitializeMainApp;
